import React, { useState, useEffect } from 'react';
import { db } from '../firebase'; 
import { collection, query, where, onSnapshot, orderBy } from 'firebase/firestore';
import { format, subDays, eachDayOfInterval } from 'date-fns';
import { BarChart3, TrendingUp, Calendar } from 'lucide-react';

const WinnieReport = ({ user }) => {
    const [history, setHistory] = useState([]);
    const [stats, setStats] = useState({ bakingSoda: 0, rehmannia: 0, chores: 0 });

    useEffect(() => {
        if (!user) return;
        const thirtyDaysAgo = subDays(new Date(), 30);
        const q = query(
            collection(db, 'personal_chores'), 
            where('userId', '==', user.uid),
            where('status', '==', 'completed'),
            orderBy('timestamp', 'desc')
        );

        return onSnapshot(q, (snapshot) => {
            const data = snapshot.docs.map(d => d.data());
            setHistory(data);

            // Calculate Stats for the last 30 days
            setStats({
                bakingSoda: data.filter(d => d.label.includes('Baking Soda')).length,
                rehmannia: data.filter(d => d.label.includes('Rehmannia')).length,
                chores: data.filter(d => d.group === 'manual_chore').length
            });
        });
    }, [user]);

    return (
        <div className="max-w-md mx-auto bg-slate-950 p-6 rounded-3xl border border-pink-500/20 shadow-2xl mt-6">
            <h2 className="text-xl font-black text-pink-500 uppercase italic mb-6 flex items-center gap-2">
                <BarChart3 size={20}/> Performance Audit
            </h2>

            {/* 30-Day Heat Map View */}
            <div className="grid grid-cols-7 gap-1 mb-8">
                {eachDayOfInterval({ start: subDays(new Date(), 27), end: new Date() }).map((day, i) => {
                    const dayStr = format(day, 'yyyy-MM-dd');
                    const isDone = history.some(h => h.date === dayStr);
                    return (
                        <div key={i} className={`h-4 rounded-sm ${isDone ? 'bg-pink-500' : 'bg-slate-800'}`} title={dayStr} />
                    );
                })}
            </div>

            {/* Statistics Cards */}
            <div className="space-y-4">
                <div className="bg-white/5 p-4 rounded-xl border border-white/5 flex justify-between items-center">
                    <div>
                        <p className="text-[10px] text-slate-500 uppercase font-bold">Baking Soda Adherence</p>
                        <p className="text-lg font-black text-white">{stats.bakingSoda} / 30 Days</p>
                    </div>
                    <TrendingUp className="text-green-500" size={24} />
                </div>

                <div className="bg-white/5 p-4 rounded-xl border border-white/5 flex justify-between items-center">
                    <div>
                        <p className="text-[10px] text-slate-500 uppercase font-bold">Client Logs Completed</p>
                        <p className="text-lg font-black text-white">{stats.chores} Total Tasks</p>
                    </div>
                    <Calendar className="text-indigo-400" size={24} />
                </div>
            </div>
        </div>
    );
};

export default WinnieReport;